export const VIDEO_EDITOR = 1;
export const SOCIAL_MEDIA_MANAGER = 2;
export const CONTENT_CREATOR = 3;
export const GRAPHIC_DESIGNER = 4;
export const MARKETING_STRATEGIST = 5;

export const EXPERTISE_AREAS = [
  {
    label: "Video Editor",
    id: 1,
  },
  {
    label: "Social Media Manager",
    id: 2,
  },
  {
    label: "Content Creator",
    id: 3,
  },
  {
    label: "Graphic Designer",
    id: 4,
  },
  {
    label: "Marketing Strategist",
    id: 5,
  },
];
